import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=f4a8e460&scoped=true&"
import script from "./plain.vue?vue&type=script&lang=js&"
export * from "./plain.vue?vue&type=script&lang=js&"
import style0 from "./plain.vue?vue&type=style&index=0&id=f4a8e460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a8e460",
  null
  
)

export default component.exports